const style = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    gap: 20,
  },
  tagCard: {
    minWidth: 250,
  },
  tagHeaderRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  aboutInfoButton: {
    padding: '0 8px',
    minWidth: 30,
    minHeight: 28,
    lineHeight: 1,
  },
  clickable: { cursor: 'pointer' },
  inputAndAddButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'spaced-between',
    alignItems: 'center',
    paddingBottom: 5,
    paddingTop: 5,
    marginTop: 20,
  },
  manageFieldsNewName: {
    alignItems: 'center',
    textAlign: 'center',
    width: '97%',
    marginRight: 5,
    marginLeft: 5,
  },
  centeredText: {
    width: '100%',
    textAlign: 'center',
  },
  aboutTagsPanel: {
    paddingTop: 70,
    flex: 1,
    minWidth: 260,
    textAlign: 'center',
  },
  aboutTagsTitle: {
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '36px',
    marginBottom: 12,
    textAlign: 'center',
  },
  aboutTagsList: {
    margin: '0 auto',
    paddingLeft: 0,
    listStylePosition: 'inside',
    lineHeight: '30px',
    textAlign: 'center',
  },
  aboutTagsTitleMobile: {
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8,
    textAlign: 'center',
  },
  aboutTagsListMobile: {
    margin: '0 auto',
    paddingLeft: 0,
    listStylePosition: 'inside',
    lineHeight: '22px',
    fontSize: 14,
    textAlign: 'center',
  },
};
export default style;
